module.exports = __webpack_public_path__ + "img/Filter_Line_16px_Icon-light.be222033.svg";